var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtpWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32506 11.9381C8.47958 11.7595 8.66296 11.6179 8.86474 11.5213C9.06652 11.4247 9.28275 11.3751 9.50108 11.3754C9.71942 11.3756 9.93558 11.4256 10.1372 11.5225C10.3389 11.6194 10.5221 11.7614 10.6763 11.9403C10.8306 12.1192 10.9529 12.3315 11.0363 12.5652C11.1197 12.7988 11.1625 13.0492 11.1623 13.302C11.1621 13.5548 11.119 13.8051 11.0353 14.0386C10.9515 14.2721 10.8289 14.4842 10.6744 14.6628C10.3622 15.0235 9.9391 15.2259 9.49806 15.2254C9.05703 15.2249 8.63423 15.0215 8.32269 14.6601C8.01115 14.2986 7.83637 13.8086 7.83682 13.298C7.83726 12.7873 8.01289 12.2988 8.32506 11.9381ZM3.23022 8.9076C6.68822 4.9036 12.3122 4.9036 15.7702 8.9076L14.2027 10.7226C12.9547 9.28028 11.2635 8.47023 9.50022 8.47023C7.73695 8.47023 6.04572 9.28028 4.79772 10.7226L3.23022 8.9076ZM0.0952148 5.2776C5.28222 -0.727299 13.7182 -0.727299 18.9052 5.2776L17.3377 7.0926C13.0152 2.0876 5.98522 2.0876 1.66271 7.0926L0.0952148 5.2776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtpWhite);
export default __webpack_public_path__ + "static/media/ftpWhite.28312f83cd6ff6c0b6b1f4719793f509.svg";
export { ForwardRef as ReactComponent };